export default __webpack_public_path__ + "static/media/portfolio-154.703644c2.jpg";